import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import { ToastType, useToast } from "../../../../context_providers/toast/toast_ctx";
import { SearchCustomerGroupInCustomer } from "./customer_repo";
import AutoCompleteField from "../../../../ui/new_components/common/autocomplete";

interface CustomrerGroupSearchWidgetProps {
  onSelect: (data: any) => void;
  placeholder?: string;
  value?: string;
  emp?: { uid: string; name: string };
  disabled?: boolean;
  withBtn?: boolean;
  id?: string;
}

const CustomerGroupSearchWidget: FunctionComponent<CustomrerGroupSearchWidgetProps> = ({
  onSelect,
  placeholder,
  value,
  disabled = false,
  id,
}) => {
  const { showToast } = useToast();
  const [search, setSearch] = useState("");
  const [edit, setEdit] = useState(false);
  const [group, setGroup] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (search && edit) {
      debouncedHandler(search);
    }
  }, [search]);

  const searchCustomerGroup = async (search: string) => {
    setLoading(true);
    const res = await SearchCustomerGroupInCustomer(search);
    if (res.success) {
      setGroup(res.data);
    } else {
      setGroup([]);
      showToast({ type: ToastType.error, text: res.error ?? "" });
    }
    setLoading(false);
  };
  const debouncedHandler = useCallback(
    debounce((query) => {
      if (query) searchCustomerGroup(query);
    }, 500),
    [search]
  );

  return (
    <div className="flex gap-1 items-center w-full">
      {edit ? (
        <AutoCompleteField
          id={id}
          loading={loading}
          value={search}
          placeholder={placeholder ?? "Assets"}
          onSelect={(val) => {
            console.log("AutoCompleteField Componenet", val.value);
            setEdit(false);
            setSearch(val.value);
            onSelect(val.value);
          }}
          suggestions={group.map((e) => ({
            label: (
              <div className="text-xs">
                <b>{e.additional_customer_details?.customer_group}</b>
              </div>
            ),

            value: e.additional_customer_details?.customer_group,
          }))}
          onChange={(str) => {
            setSearch(str);
            onSelect(str);
          }}
        />
      ) : (
        <div
          id={id}
          className="text-sm px-3 py-2 bg-white  h-10 rounded focus:outline-none w-full border"
          onClick={() => {
            if (!disabled) {
              setEdit(true);
              console.log(disabled);
            }
          }}
        >
          
          {search || value}
        </div>
      )}
    </div>
  );
};

export default CustomerGroupSearchWidget;
